export const getConfig = ({ i18n, insuracePortalUserRole }) => ({
  tableColumns: [
    ...(insuracePortalUserRole
      ? [
          {
            id: 'companyName',
            numeric: false,
            disablePadding: false,
            label: i18n.t('policyHolder'),
            needSorting: false
          }
        ]
      : []),
    {
      id: 'behavior',
      numeric: false,
      disablePadding: false,
      label: i18n.t('Behavior'),
      needSorting: true
    },
    {
      id: 'day',
      numeric: true,
      disablePadding: true,
      label: i18n.t('Date'),
      needSorting: true
    },
    {
      id: 'severity',
      numeric: false,
      disablePadding: false,
      label: i18n.t('Severity'),
      needSorting: true
    },
    {
      id: 'vehicleName',
      numeric: false,
      disablePadding: false,
      label: i18n.t('common.vehicle'),
      needSorting: true
    },
    {
      id: 'behaviorScore',
      numeric: true,
      disablePadding: false,
      label: i18n.t('Behavior Score'),
      needSorting: true
    },
    {
      id: 'severityScore',
      numeric: true,
      disablePadding: false,
      label: i18n.t('Severity Score'),
      needSorting: true
    },
    {
      id: 'totalScore',
      numeric: true,
      disablePadding: false,
      label: i18n.t('Total Score'),
      needSorting: true
    }
  ]
});

export const monthVals = [
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12'
];

export const sortColumnMapping = {
  unitId: 'vehicleName',
  work_order_id: 'idPub',
  type: 'unitType',
  reported_date: 'createDate',
  scheduled_date: 'beginDate',
  due_date: 'endDate',
  workOrderType: 'type',
  status: 'state'
};

export const basicRequest = {
  displayLength: '10',
  displayStart: '1'
};